const BASE_CONFIG = require('./base.json')

class AppConfig {
  detectEnv() {
    if (process.env.NODE_ENV === 'production') return 'live'
    this.currentHost = window.location.hostname
    return ['localhost', '127.0.0.1', '::1', '[::1]'].includes(this.currentHost)
      ? 'local'
      : 'live'
  }

  getConfig(env) {
    this.config = {}
    /* eslint-disable global-require */
    if (env === 'prod') {
      this.config = require('./prod.json')
    } else if (env === 'live') {
      this.config = require('./live.json')
    } else {
      this.config = require('./local.json')
    }
    /* eslint-enable global-require */
    return { ...BASE_CONFIG, ...this.config }
  }

  load() {
    const env = this.detectEnv()
    const config = this.getConfig(env)
    return config
  }
}

export default new AppConfig()
